import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../constants";

const Redirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(ROUTE.HOME, { replace: true });
  }, [navigate]);

  return null;
};

export default Redirect;
